// extracted by mini-css-extract-plugin
export default {"errorContainer":"no-data-message_errorContainer__ntt7d","noDataImg":"no-data-message_noDataImg__8nI4l"};